
const Cookies = () => Object.freeze({
    cookies: () =>{
        if (!document.cookie) return null;
        const map = new Map();
        document.cookie.split(';').forEach((e) => {
            _e = e ? e.trim() : '';
            if (_e) {
                const [k, v] = _e.split('=');
                if (k && v) map.set(k, v);
            }
        });

        return map;
    },

    get(key) {
        return this.cookies().get(key);
    },

    set(key, value, { expiresIn }) {
        document.cookie = `${key}=${value}; path=/; expires=${expiresIn}`;
        return this.cookies();
    }
});


